"use client";
import {
  __async
} from "../../chunk-MMUBH76A.js";
import { WalletType } from "@getpara/web-sdk";
import { useInternalClient } from "../../provider/hooks/utils/useInternalClient.js";
import { useWalletState } from "../../provider/index.js";
import { useExternalWalletProviderStore } from "../stores/externalWalletProvider/useExternalWalletProviderStore.js";
const useEmbeddedExternalConnection = () => {
  const client = useInternalClient();
  const { setSelectedWallet } = useWalletState();
  const connectParaEvmWallet = useExternalWalletProviderStore((state) => state.connectParaEvmWallet);
  const EvmProvider = useExternalWalletProviderStore((state) => state.EvmProvider);
  const evmContext = useExternalWalletProviderStore((state) => state.evmContext);
  const connectParaCosmosWallet = useExternalWalletProviderStore((state) => state.connectParaCosmosWallet);
  const CosmosProvider = useExternalWalletProviderStore((state) => state.CosmosProvider);
  const cosmosContext = useExternalWalletProviderStore((state) => state.cosmosContext);
  const connectEmbeddedToExternalConnectors = () => __async(void 0, null, function* () {
    if (evmContext && EvmProvider && connectParaEvmWallet) {
      try {
        const { error } = yield connectParaEvmWallet();
        if (error) {
          console.warn("Failed to connect Para EVM wallet to Wagmi:", error);
        } else {
          const wallet = client.findWallet(void 0, void 0, { type: [WalletType.EVM] });
          if (wallet) {
            setSelectedWallet({ id: wallet.id, type: WalletType.EVM });
          }
        }
      } catch (err) {
        console.warn("Error calling connectParaEvmWallet:", err);
      }
    }
    if (cosmosContext && CosmosProvider && connectParaCosmosWallet) {
      try {
        const { error } = yield connectParaCosmosWallet();
        if (error) {
          console.warn("Failed to connect Para Cosmos wallet to Graz:", error);
        } else {
          const wallet = client.findWallet(void 0, void 0, { type: [WalletType.COSMOS] });
          if (wallet) {
            setSelectedWallet({ id: wallet.id, type: WalletType.COSMOS });
          }
        }
      } catch (err) {
        console.warn("Error calling connectParaCosmosWallet:", err);
      }
    }
  });
  return connectEmbeddedToExternalConnectors;
};
export {
  useEmbeddedExternalConnection
};
